module.exports = __webpack_public_path__ + "img/logoB.cc6be659.png";